import { message, Modal, Typography } from 'antd'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { userSelector } from '@/redux/selectors'
import { useResetPin } from '@/utils/queries'
import { POS_ONLINE_HEADER } from '@/utils/static'
import ResetPINForm from './ResetPINForm'
import { Cancel, Save } from '@/components/UI'

const { Text } = Typography

const ResetPINOnModal = ({ open, onCancel, ...props }) => {
  const { formatMessage } = useIntl()

  const user = useSelector(userSelector)

  const { mutate, isLoading } = useResetPin()

  // Handle submit form
  const handleSubmit = useCallback(
    ({ values, callback }) => {
      const payload = {
        ...values,
        id: user.id,
      }
      mutate(
        { ...payload, apiOptions: POS_ONLINE_HEADER },
        {
          onSuccess: (response) => {
            if (response.data.success) {
              message.success(formatMessage({ id: 'pin_reset_successfully' }))
              if (typeof callback === 'function') {
                callback()
              }
            } else {
              message.error(response.data.message)
            }
          },
          onError: (error) => {
            message.error(error.data?.message || 'Failed to reset PIN')
          },
        },
      )
    },
    [mutate, user.id, formatMessage],
  )

  return (
    <Modal
      title={
        <Text strong style={{ fontSize: 16 }}>
          {formatMessage({ id: 'reset_your_current_pin' })}
        </Text>
      }
      footer={[
        <Cancel key="cancel" onClick={onCancel} />,
        <Save
          key="save"
          htmlType="submit"
          form="ResetPINForm"
          loading={isLoading}
          title="Reset PIN"
        />,
      ]}
      open={open}
      onCancel={onCancel}
      destroyOnHidden
      {...props}
    >
      <ResetPINForm withSubmitAction={false} onSubmit={handleSubmit} loading={isLoading} />
    </Modal>
  )
}

export default ResetPINOnModal
